import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  thematic_types: [],
  thematic_type: null
}

// mutations
export const mutations = {
  [types.SET_THEMATIC_TYPES] (state, thematic_types) {
    state.thematic_types = thematic_types
  },
  [types.SET_THEMATIC_TYPE] (state, thematic_type) {
    state.thematic_type = thematic_type
  },
  [types.FETCH_THEMATIC_TYPE_FAILURE] (state) {
    state.thematic_type = null
  }
}

// actions
export const actions = {
  async fetchThematicTypes ({ commit }) {
    try {
      const uri = '/api/thematic-types?include=event_type'
      const { data } = await axios.get(uri)
      commit(types.SET_THEMATIC_TYPES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchThematicType ({ commit }, thematic_type) {
    try {
      const uri = '/api/thematic-types'
      const { data } = await axios.get(`${uri}/${thematic_type.id}`)

      commit(types.SET_THEMATIC_TYPE, { thematic_type: data })
    } catch (e) {
      commit(types.FETCH_THEMATIC_TYPE_FAILURE)
    }
  },

  async createThematicType (context, thematic_type) {
    try {
      await axios.post('/api/thematic-types', thematic_type)
      context.dispatch('fetchThematicTypes')
    } catch (e) {
      console.log(e)
    }
  },

  async updateThematicType (context, thematic_type) {
    try {
      await axios.put(`/api/thematic-types/${thematic_type.id}`, thematic_type)
      context.dispatch('fetchThematicTypes')
    } catch (e) { }
  },

  async deleteThematicType (context, thematic_type) {
    try {
      await axios.delete(`/api/thematic-types/${thematic_type.id}`)
      context.dispatch('fetchThematicTypes')
    } catch (e) { }
  }
}

// getters
export const getters = {
  thematic_types: state => state.thematic_types
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/thematic-type.js